import { FormLabel, TextField } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import React, { memo } from 'react';
import { ErrorMessage } from '@hookform/error-message';

const TextFieldRhf = ({
    name,
    defaultValue = '',
    TextFieldStyle = { width: '90%' },
    question,
    multiline = false,
    disabled = false,
    readOnly = false,
}) => {
    const {
        formState: { errors },
        control,
    } = useFormContext();

    return (
        <>
            <FormLabel component="legend" style={{ marginBottom: 4 }}>
                {question}
            </FormLabel>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <TextField
                        disabled={disabled}
                        multiline={multiline}
                        minRows={multiline ? 4 : 0}
                        style={TextFieldStyle}
                        variant="outlined"
                        {...field}
                        InputProps={{
                            readOnly: readOnly,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                )}
                defaultValue={defaultValue}
            />
            <div style={{ marginLeft: 8 }}>
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                />
            </div>
        </>
    );
};

export default TextFieldRhf;
